module.exports = require("pdfjs-dist/legacy/build/pdf");